import { useEffect } from 'react';

/**
 * Inject a JSON-LD <script> into <head> for the lifetime of the component.
 * Google reads DOM-injected structured data on JS-rendered pages. Each block
 * gets a stable id so re-renders replace rather than duplicate.
 */
export default function JsonLd({ id, data }: { id: string; data: unknown }): null {
  useEffect(() => {
    const elId = `jsonld-${id}`;
    let el = document.getElementById(elId) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      document.getElementById(elId)?.remove();
    };
  }, [id, data]);
  return null;
}
